<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="IAAttendanceForm">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class="row">
                                            <div class="col-md-6 prpl">
                                                <div class=" d-flex align-items-center">
                                                    <img alt="Logo" src="../../assets/img/attendance.png" class="mh-45px pb-2">
                                                    <p class="mb-1">
                                                        <span class="main-content-label"><b>Student Practical Attendance</b></span><br>
                                                        <span class="text-muted card-sub-title mb-0">List Of Student Practical
                                                            Attendance</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-1"></div>
                                            <!-- <div  class="col-md-3 mt-2 curr">
                                                <h3 (click)="dowload()" class="main-content-label mb-1"><b>
                                                    File Download
                                                    <img alt="Logo" src="../../assets/images/arrow (1).png" class="mh-45px curr pb-2">
                                                </b></h3>
                                             </div>
                                            </div> -->
                                            <!-- <div  class="col-sm-2 mt-2 curr" *ngIf="IsFile">
                                                <h3 (click)="download2()" class="main-content-label mb-1"><b>
                                                    File Download
                                                    <img alt="Logo" src="../../assets/images/arrow (1).png" class="mh-45px curr pb-2">
                                                </b></h3>
                                             </div> -->
                                             <div class="col-sm-3 curr">
                                                <button type="button" *ngIf="IsFile"
                                                class="btn size1 curr btn-primary btn-icon-text floatright mt-1 file-upload-button">
                                                <input type="file" (click)="download2($event)" />
                                                <span style="display: contents; align-items: center;">
                                                    <img alt="Logo" src="../../assets/images/arrow (1).png" class="mh-45px curr pb-2">
                                                        File Download
                                                </span>
                                            </button>
                                        </div>
                                             <div class="col-sm-2" *ngIf="IsFile">
                                                <button type="button" 
                                                class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1 file-upload-button">
                                                <input type="file" #fileInput (change)="File($event)"
                                                    accept=".csv" />
                                                <span style="display: contents; align-items: center;">
                                                    <img width="15vh" src="../../assets/img/upload.gif"
                                                        style="margin-right: 7px;">
                                                    File
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="row clearfix mt-2">
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                                            formControlName="SessionId">
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo" >
                                                                <!-- (click)="getCourse(item.SnNo)" -->
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>

                                            </div>
                                        </div>
                                         <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <mat-select #select23
                                                            formControlName="college" [displayMember]="'CgName'">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode" (click)="getCourse(item.CgCode)">
                                                                {{item.CgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select #select55 class="colorblack"
                                                            formControlName="course">
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode"
                                                                 (click)="getExamList(item.CoCode)">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                           Exam
                                                        </mat-label>
                                                        <mat-select #select2389 placeholder="CoCode"
                                                            formControlName="EmId">
                                                            <mat-select-filter *ngIf="select2389.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="examList"
                                                                (filteredReturn)="filteredListExam =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExam"
                                                                [value]="item.EmId" (click)="getSubject(item)">
                                                                {{item.EmCoCode}}-{{item.EmName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-2" *ngIf="isBranch">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                           Branch
                                                        </mat-label>
                                                        <mat-select #select2392 placeholder="CoCode"
                                                            formControlName="Branch">
                                                            <mat-select-filter *ngIf="select2392.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId" (click)="getStr(item)">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                           Subject
                                                        </mat-label>
                                                        <mat-select #select2390 placeholder="CoCode"
                                                            formControlName="EsParentId" >
                                                            <mat-select-filter *ngIf="select2390.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="subjectList"
                                                                (filteredReturn)="filteredsubjectList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredsubjectList"
                                                                [value]="item.EsId" (click)="subjectClick(item)">
                                                             {{item.EsCode}}-{{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                           Practical
                                                        </mat-label>
                                                        <mat-select #select2391 placeholder="CoCode"
                                                            formControlName="EsId" >
                                                            <mat-select-filter *ngIf="select2391.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="HeadList"
                                                                (filteredReturn)="filteredListHead =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListHead"
                                                                [value]="item.EsId"  (click)="getHeadCode(item.EsCode)">
                                                             {{item.EsCode}}-{{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    
                                    </div>
                                        <div *ngIf="Table" class="table-responsive mt-4">
                                            <div class="container">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th class="f600" width="8%">
                                                                Sr.No
                                                            </th>
                                                            <th class="f600">
                                                                Student Name
                                                            </th>
                                                            <th class="f600">
                                                                Attendance
                                                            </th>
                                                            <th class="f600 hidden">
                                                               Status
                                                            </th>
                                                            <th class="f600 hidden text-center ">
                                                                Student Id
                                                            </th>

                                                            <th class="f600 hidden text-center ">
                                                                Scrutiny Id
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="StuArray">
                                                        <tr  *ngFor="let markData of getStuArrayControls(); let i = index" 
                                                        [formGroupName]="i">
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm"
                                                                formControlName="SrNo">
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm"
                                                                formControlName="Name">
                                                            </td>
                                                            <td>
                                                                <input class="tab3 form-control text-center"
                                                                formControlName="Attendance" maxlength="3" (keyup)="onInputChange2($event,i)">
                                                                <mat-error class="margin_tp mrgtp"
                                                                    *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.pattern">
                                                                    Invalid
                                                                </mat-error>
                                                                <mat-error class="margin_tp mrgtp"
                                                                    *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.max">
                                                                    Enter Less Than or Equal To 100
                                                                </mat-error>
                                                                <mat-error class="margin_tp mrgtp"
                                                                    *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                                <!-- <mat-error class="margin_tp" *ngIf="errorcheckR(markData)">
                                                                    Invalid 
                                                                </mat-error> -->
                                                            </td>
                                                            <td class="hidden">
                                                                <mat-form-field appearance="outline">
                                                                        <mat-label>
                                                                            Status
                                                                        </mat-label>
                                                                        <mat-select #select53 class=""
                                                                            formControlName="Status">
                                                                            
                                                                            <mat-option value="Y">
                                                                                Approve
                                                                            </mat-option>
                                                                            <mat-option value="N">
                                                                                Deny
                                                                            </mat-option>
                                                                        </mat-select>
                                                                    </mat-form-field>
                                                                <!-- <input readonly class="tab2 form-control input-sm"
                                                                formControlName="Status"> -->
                                                            </td>
                                                            <td class="hidden">
                                                                <input readonly class="tab2 form-control hidden input-sm"
                                                                formControlName="StuId">
                                                            </td>
                                                            <td class="hidden">
                                                                <input readonly class="tab2 form-control hidden input-sm"
                                                                formControlName="SctId">
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                           
                                        </div>
                                        <div *ngIf="Table" class="col-sm-12 mb-3">
                                            <p><b>The required attendance is {{attendance}} for this subject</b></p>
                                        </div>
                                        
                                    </div>
                                    <div class="col-sm-12">
                                           
                                        <button *ngIf="SaveBtn && IaAtdCreate" type="button"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                            (click)="Save()" [disabled]="saveDisable">
                                            <span style="display: contents; align-items: center;">
                                                <img width="15vh" src="../../assets/img/save.gif"
                                                    style="margin-right: 7px;">
                                                    Save
                                            </span>
                                        </button>
                                        <button *ngIf="UpdateBtn && IaAtdUpdate" type="button"
                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                        (click)="update()" [disabled]="updateDisable">
                                        <span style="display: contents; align-items: center;">
                                            <img width="15vh" src="../../assets/img/edit1.gif"
                                                style="margin-right: 7px;">
                                                Update
                                        </span>
                                    </button>
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>